import { render, staticRenderFns } from "./lock-course.vue?vue&type=template&id=0a5cb842&scoped=true&"
import script from "./lock-course.vue?vue&type=script&lang=js&"
export * from "./lock-course.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5cb842",
  null
  
)

export default component.exports